import styled from 'styled-components';

import { sizeDown } from '~/theme';
import ConfigurableModal from '~organisms/ConfigurableModal';

export const Container = styled(ConfigurableModal)(({ theme }) => ({
  '& .ant-modal-title': {
    fontSize: theme.typography.size24,
    color: theme.palette.artichoke,
    fontWeight: 'bold',
    fontFamily: theme.typography.family.arial,
  },

  '& .ant-modal-content': {
    width: sizeDown('50vw', ['md', '700rem']),
    padding: '30rem',
  },

  '& .ant-modal-footer': {
    display: 'flex',
    justifyContent: 'center',
    paddingBlockStart: '10rem',

    '& link': {
      fontSize: theme.typography.size20,
    },
  },

  '& .modal-content': {
    justifyContent: 'flex-start',
    fontSize: theme.typography.size16,
    marginTop: '26rem',
    fontFamily: theme.typography.family.arial,
    color: theme.palette.erieBlack,
    maxHeight: '75vh',
  },
}));
